import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Navbar } from "./components/Navbar";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import Generate from "./pages/Generate";
import Predictions from "./pages/Predictions";
import Insights from "./pages/Insights";
import Topics from "./pages/Topics";
import TopicDetail from "./pages/TopicDetail";
import Examiner from "./pages/Examiner";
import Analytics from "./pages/Analytics";
import PaperView from "./pages/PaperView";
import Library from "./pages/Library";
import AdminLabels from "./pages/AdminLabels";
import Profile from "./pages/Profile";
import AuthCallback from "./pages/AuthCallback";
import ExamMode from "./pages/ExamMode";
import SubmissionReview from "./pages/SubmissionReview";
import MyPapers from "./pages/MyPapers";
import About from "./pages/About";

const P = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth return BEFORE any protected-route auth checks run
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/signup" element={<AuthPage mode="signup" />} />
      <Route path="/dashboard" element={<P><Dashboard /></P>} />
      <Route path="/generate" element={<P><Generate /></P>} />
      <Route path="/predictions" element={<P><Predictions /></P>} />
      <Route path="/insights" element={<P><Insights /></P>} />
      <Route path="/topics" element={<P><Topics /></P>} />
      <Route path="/topics/:topic" element={<P><TopicDetail /></P>} />
      <Route path="/examiner" element={<P><Examiner /></P>} />
      <Route path="/analytics" element={<P><Analytics /></P>} />
      <Route path="/my-papers" element={<P><MyPapers /></P>} />
      <Route path="/papers" element={<Navigate to="/my-papers" replace />} />
      <Route path="/papers/:id" element={<P><PaperView /></P>} />
      <Route path="/exam/:id" element={<P><ExamMode /></P>} />
      <Route path="/submissions" element={<Navigate to="/my-papers?tab=completed" replace />} />
      <Route path="/submissions/:id" element={<P><SubmissionReview /></P>} />
      <Route path="/library" element={<P><Library /></P>} />
      <Route path="/admin/labels" element={<P><AdminLabels /></P>} />
      <Route path="/profile" element={<P><Profile /></P>} />
      <Route path="/about" element={<About />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Navbar />
            <AppRouter />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
